import { render, staticRenderFns } from "./CardLayer.vue?vue&type=template&id=08c2ce56&"
import script from "./CardLayer.vue?vue&type=script&lang=js&"
export * from "./CardLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports